<script lang="ts">
  import { store } from "./store";
  const toastStore = store;
</script>

{#if $toastStore.length > 0}
  <div
    class="
      toast
      fixed bottom-[64px] left-[50%] transform -translate-x-[50%] max-w-[440px]
      text-white transition-opacity bg-opacity-0 duration-100
    "
  >
    {#each $toastStore as toast}
      <div
        class="rounded-[5px] px-[16px] min-h-[40px] font-urbanist flex align-middle items-center justify-center mt-[8px]"
        class:success={toast.kind === "success"}
        class:error={toast.kind === "error"}
        class:info={toast.kind === "info"}
      >
        {toast.message}
      </div>
    {/each}
  </div>
{/if}

<style lang="postcss">
  .info {
    @apply bg-[#062427];
  }
  .success {
    @apply bg-[#259365];
  }
  .error {
    @apply bg-[#e2533f];
  }
  .toast {
    z-index: 60;
  }
</style>
